document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.testimonials-section');

  sections.forEach(function (section) {
    const track = section.querySelector('.testimonials-track');
    const slides = section.querySelectorAll('.testimonial-slide');
    const prevBtn = section.querySelector('.testimonials-arrow--prev');
    const nextBtn = section.querySelector('.testimonials-arrow--next');
    const dots = section.querySelectorAll('.testimonials-dot');

    if (!track || slides.length === 0) return;

    const totalSlides = slides.length;
    const slidesPerView = window.innerWidth <= 768 ? 1 : 2;
    const totalSteps = Math.ceil(totalSlides / slidesPerView);
    let currentStep = 0;
    let autoPlayTimer = null;
    let isTransitioning = false;

    // Clone slides for infinite loop feel
    // Add clones at start and end
    const originalSlides = Array.from(slides);

    // Clone last set and prepend
    const lastClones = originalSlides.slice(-slidesPerView).map(s => s.cloneNode(true));
    lastClones.forEach(clone => track.insertBefore(clone, track.firstChild));

    // Clone first set and append
    const firstClones = originalSlides.slice(0, slidesPerView).map(s => s.cloneNode(true));
    firstClones.forEach(clone => track.appendChild(clone));

    // Total slides after cloning
    const allSlides = track.querySelectorAll('.testimonial-slide');
    const totalWithClones = allSlides.length;

    // Start at first real slide (after prepended clones)
    let realIndex = slidesPerView; // offset by cloned slides

    // Set initial position without animation
    function setPositionSilent(index) {
      track.style.transition = 'none';
      track.style.transform = `translateX(-${index * (100 / slidesPerView)}%)`;
    }

    function updateDots(step) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('active', i === step);
      });
    }

    function goToSlide(index, step) {
      if (isTransitioning) return;
      isTransitioning = true;

      track.style.transition = 'transform 0.5s ease';
      track.style.transform = `translateX(-${index * (100 / slidesPerView)}%)`;
      realIndex = index;
      currentStep = step;
      updateDots(currentStep);

      setTimeout(function () {
        // If we went to a clone - jump silently to real slide
        if (realIndex >= totalWithClones - slidesPerView) {
          // Went past end clone - jump to real start
          realIndex = slidesPerView;
          currentStep = 0;
          setPositionSilent(realIndex);
          updateDots(currentStep);
        } else if (realIndex < slidesPerView) {
          // Went before start clone - jump to real end
          realIndex = totalWithClones - slidesPerView * 2;
          currentStep = totalSteps - 1;
          setPositionSilent(realIndex);
          updateDots(currentStep);
        }
        isTransitioning = false;
      }, 500);
    }

    function goNext() {
      const nextIndex = realIndex + slidesPerView;
      const nextStep = currentStep + 1 >= totalSteps ? 0 : currentStep + 1;
      goToSlide(nextIndex, nextStep);
    }

    function goPrev() {
      const prevIndex = realIndex - slidesPerView;
      const prevStep = currentStep - 1 < 0 ? totalSteps - 1 : currentStep - 1;
      goToSlide(prevIndex, prevStep);
    }

    // Auto play
    function startAutoPlay() {
      stopAutoPlay();
      autoPlayTimer = setInterval(function () {
        goNext();
      }, 5000);
    }

    function stopAutoPlay() {
      if (autoPlayTimer) {
        clearInterval(autoPlayTimer);
        autoPlayTimer = null;
      }
    }

    // Arrow buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stopAutoPlay();
        goPrev();
        startAutoPlay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stopAutoPlay();
        goNext();
        startAutoPlay();
      });
    }

    // Dots
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        stopAutoPlay();
        const targetIndex = slidesPerView + (i * slidesPerView);
        goToSlide(targetIndex, i);
        startAutoPlay();
      });
    });

    // Touch/swipe support for mobile
    let touchStartX = 0;
    let touchEndX = 0;

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoPlay();
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) goNext();
        else goPrev();
      }
      startAutoPlay();
    }, { passive: true });

    // Initialize
    setPositionSilent(realIndex);
    updateDots(0);
    startAutoPlay();
  });
});
